module.exports = __webpack_public_path__ + "static/media/close-circle-line.ab780cdd.svg";